{
  "login": {
    "title": "Iniciar Sesión",
    "subtitle": "Bienvenido de nuevo",
    "emailLabel": "Correo Electrónico",
    "emailPlaceholder": "Ingrese su correo electrónico",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Ingrese su contraseña",
    "rememberMe": "Recuérdame",
    "forgotPassword": "¿Olvidó su contraseña?",
    "submitButton": "Iniciar Sesión",
    "loggingIn": "Iniciando sesión...",
    "errors": {
      "emailRequired": "El correo electrónico es requerido",
      "passwordRequired": "La contraseña es requerida",
      "invalidCredentials": "Correo electrónico o contraseña inválidos",
      "accountDisabled": "Su cuenta ha sido deshabilitada",
      "tooManyAttempts": "Demasiados intentos de inicio de sesión. Por favor, intente más tarde."
    }
  },
  "forgotPassword": {
    "title": "Restablecer Contraseña",
    "subtitle": "Ingrese su correo electrónico para recibir instrucciones",
    "emailLabel": "Correo Electrónico",
    "emailPlaceholder": "Ingrese su correo electrónico",
    "submitButton": "Enviar Enlace de Restablecimiento",
    "sending": "Enviando...",
    "backToLogin": "Volver a Iniciar Sesión",
    "success": "Las instrucciones para restablecer la contraseña han sido enviadas a su correo",
    "errors": {
      "emailRequired": "El correo electrónico es requerido",
      "invalidEmail": "Por favor ingrese un correo electrónico válido",
      "emailNotFound": "No se encontró ninguna cuenta con este correo electrónico",
      "rateLimited": "Demasiadas solicitudes. Por favor, intente más tarde."
    }
  },
  "resetPassword": {
    "title": "Crear Nueva Contraseña",
    "subtitle": "Ingrese su nueva contraseña",
    "passwordLabel": "Nueva Contraseña",
    "passwordPlaceholder": "Ingrese nueva contraseña",
    "confirmPasswordLabel": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Reingrese nueva contraseña",
    "submitButton": "Restablecer Contraseña",
    "resetting": "Restableciendo...",
    "success": "Su contraseña ha sido restablecida exitosamente",
    "backToLogin": "Volver a Iniciar Sesión",
    "errors": {
      "passwordRequired": "La contraseña es requerida",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "passwordComplexity": "La contraseña debe contener al menos 3 de: minúsculas, mayúsculas, dígitos, caracteres especiales",
      "passwordMismatch": "Las contraseñas no coinciden",
      "tokenInvalid": "Enlace de restablecimiento inválido o expirado",
      "tokenExpired": "Este enlace de restablecimiento ha expirado. Por favor, solicite uno nuevo."
    }
  },
  "expiredInvite": {
    "title": "Invitación Expirada",
    "message": "Esta invitación ha expirado",
    "requestNew": "Solicitar Nueva Invitación",
    "requestingNew": "Solicitando...",
    "emailLabel": "Correo Electrónico",
    "emailPlaceholder": "Ingrese su correo electrónico",
    "success": "Una nueva invitación ha sido enviada a su correo",
    "contactSupport": "Si continúa teniendo problemas, por favor contacte a soporte",
    "errors": {
      "emailRequired": "El correo electrónico es requerido",
      "invalidEmail": "Por favor ingrese un correo electrónico válido",
      "noInviteFound": "No se encontró ninguna invitación para este correo",
      "alreadyUsed": "Esta invitación ya ha sido utilizada",
      "rateLimited": "Demasiadas solicitudes. Por favor, intente más tarde."
    }
  },
  "acceptInvite": {
    "title": "Cree Su Cuenta",
    "subtitle": "Complete su registro para comenzar",
    "emailLabel": "Correo Electrónico",
    "nameLabel": "Nombre Completo",
    "countryLabel": "País",
    "countryUSA": "Estados Unidos",
    "countryNonUSA": "Fuera de EE.UU.",
    "minimumContribution": "Contribución Mínima",
    "invitationCode": "Código de Invitación",
    "timeRemaining": "Tiempo Restante",
    "hours": "horas",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Ingrese su contraseña",
    "confirmPasswordLabel": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Confirme su contraseña",
    "passwordRequirementsTitle": "La contraseña debe contener al menos 3 de los siguientes:",
    "requirement1": "Al menos 8 caracteres",
    "requirement2": "Contiene letra mayúscula (A-Z)",
    "requirement3": "Contiene letra minúscula (a-z)",
    "requirement4": "Contiene número (0-9)",
    "requirement5": "Contiene carácter especial (!@#$%...)",
    "complexityLabel": "Complejidad: {{count}}/4 criterios cumplidos",
    "termsLabel": "Acepto los",
    "termsLink": "Términos y Condiciones",
    "submitButton": "Crear Cuenta",
    "creating": "Creando Cuenta...",
    "success": "¡Cuenta creada exitosamente! Redirigiendo...",
    "errors": {
      "passwordRequired": "Por favor ingrese una contraseña",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "passwordComplexity": "La contraseña debe contener al menos 3 de: mayúsculas, minúsculas, números, símbolos",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordConfirmRequired": "Por favor confirme su contraseña",
      "termsRequired": "Debe aceptar los términos y condiciones",
      "inviteInvalid": "Código de invitación inválido",
      "inviteExpired": "Esta invitación ha expirado",
      "inviteUsed": "Esta invitación ya ha sido utilizada",
      "accountExists": "Ya existe una cuenta con este correo electrónico"
    }
  }
}
